module.exports = __webpack_public_path__ + "static/media/refresh.0ac16452.svg";